var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Datepicker',{class:`element ${_vm.size}`,attrs:{"lang":_vm.language,"position":_vm.position,"range":_vm.range,"input-class":"input-custom"},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }